import axios from "axios";
import { localEnvVariables } from "../constants/env";

const Axios = axios.create({
    baseURL: localEnvVariables.REACT_APP_SUPERBASE_BASEURL,
    headers: {
        apikey: localEnvVariables.REACT_APP_SUPERBASE_APIKEY
    }
});

export const BackendAxios = axios.create({
    baseURL: localEnvVariables.REACT_APP_BACKEND_URL,
});

export default Axios;
